import {Layer} from 'ol/layer';
import Source from 'ol/source/State';
import {fromLonLat, toLonLat} from 'ol/proj';
import {getCenter, getWidth} from 'ol/extent';
import { geoVoronoi } from 'd3-geo-voronoi';

import * as d3 from 'd3';

function drawCurve(context, source, target) {
	var midPoint = [(source[0] + target[0])/2, (source[1] + target[1])/2]
	var midPoints = getCirclePoints(midPoint[0],midPoint[1], target[0], target[1], 30)
	context.moveTo(source[0], source[1])
	context.quadraticCurveTo(midPoints.leftX, midPoints.leftY, target[0], target[1])
	return context;
}

function getCirclePoints(x1,y1,x2,y2,r) {
		var startAngle = Math.atan2(y2- y1, x2-x1) * 180 / Math.PI
		var angRight = (startAngle + 90 > 360) ? (startAngle + 90 - 360) : (startAngle + 90)
		var angLeft = (startAngle - 90 < 0) ? 360 - (90 - startAngle) : (startAngle - 90)
		var rightX = x1 + r * Math.cos(angRight * 0.0174532925)
		var rightY = y1 + r * Math.sin(angRight * 0.0174532925)
		var leftX = x1 + r * Math.cos(angLeft * 0.0174532925)
		var leftY = y1 + r * Math.sin(angLeft * 0.0174532925)
		return {"rightX": rightX, "rightY": rightY, "leftX":leftX, "leftY":leftY}
	}

var CanvasLayer = /*@__PURE__*/(function (Layer) {
	function CanvasLayer(options) {
		Layer.call(this, options);

		this.features = options.features;
		this.data = options.data;
		this.onMouseOver = options.mouseOver;
		this.onMouseOut = options.mouseOut;

		this.svg = d3
			.select(document.createElement('div'))
			.append('svg')
			.style('position', 'absolute');

		this.widthScale = d3.scaleLinear()
			.domain([0, 150])
			.range([0, 15]);

		this.rScale = d3.scaleSqrt()
			.domain([0, 150])
			.range([0, 10]);

		// this.svg.append('path').datum(this.features).attr('class', 'boundary');
	
		var v = geoVoronoi()
				.x((d) => { return +d.Lat; })
				.y((d) => { return +d.Lng; })(this.data);

		this.vor = this.svg.append('g')
			.attr('class', 'polygons')
			.selectAll('path')
			.data(v.polygons().features)
			.join('path')
			.on('mousemove', (event, {properties: { site: d }}) => {
				this.onMouseOverItem(event,d);
			})
			.on('mouseout', (event, {properties: { site: d }}) => {
				this.onMouseOutItem(event,d);
			})


		this.arcs = this.svg.append("g")
			.attr("class", "arcs")
			.selectAll("g")
				.data(this.data)
				.join("g")
			.attr('class', d => { return 'g-curve knd-curve-' + d['Arrestatieplaats'].replace(' ', '').toLowerCase(); })
			.on('mousemove', (event, d) => {
				this.onMouseOverItem(event,d);
			})
			.on('mouseout', (event, d) => {
				this.onMouseOutItem(event,d);
			})

		this.importArcs = this.arcs
			.filter(d => d.Lat.length > 0)
			.append("path")
			.attr('class', 'knd-curve curve-import');

		this.importArcsSecondLayer = this.arcs
			.filter(d => d.Lat.length > 0)
			.append("path")
			.attr('class', 'knd-curve curve-import-woonwagenbewoners');

		this.exportArcs = this.arcs
			.filter(d => +d['Vrijgelaten in Westerbork '] > 0 && d.Lat.length > 0)
			.append("path")
			.attr('class', 'knd-curve curve-export');

		this.arrestment = this.arcs
				.append("circle")
				.attr('class', 'knd-circle')
			.on('mousemove', (event, d, i) => {
				this.onMouseOverItem(event,d);
			})
			.on('mouseout', (event, d) => {
				this.onMouseOutItem(event,d);
			})
	}

	if ( Layer ) CanvasLayer.__proto__ = Layer;
	CanvasLayer.prototype = Object.create( Layer && Layer.prototype );
	CanvasLayer.prototype.constructor = CanvasLayer;

	CanvasLayer.prototype.getSourceState = function getSourceState () {
		// return true;
		return Source.READY;
	};

	CanvasLayer.prototype.onMouseOverItem = function(event, d) {
		this.onMouseOver(event, d);
		this.svg.classed('selected', true);
	
		if(d['Arrestatieplaats']){
			d3.select('.knd-curve-'+ d['Arrestatieplaats'].replace(' ', '').toLowerCase()).classed('active', true)
		}
	};

	CanvasLayer.prototype.onMouseOutItem = function(event, d) {
		this.onMouseOut(event, d);

		d3.select('.g-curve.active').classed('active', false);
		this.svg.classed('selected', false);
	};

	CanvasLayer.prototype.render = function render (frameState) {
		var width = frameState.size[0];
		var height = frameState.size[1];
		var projection = frameState.viewState.projection;
		this.d3Projection = d3.geoMercator().scale(1).translate([0, 0]);
		this.d3Path = d3.geoPath().projection(this.d3Projection);

		var pixelBounds = this.d3Path.bounds(this.features);
		var pixelBoundsWidth = pixelBounds[1][0] - pixelBounds[0][0];
		var pixelBoundsHeight = pixelBounds[1][1] - pixelBounds[0][1];

		var geoBounds = d3.geoBounds(this.features);
		var geoBoundsLeftBottom = fromLonLat(geoBounds[0], projection);
		var geoBoundsRightTop = fromLonLat(geoBounds[1], projection);
		var geoBoundsWidth = geoBoundsRightTop[0] - geoBoundsLeftBottom[0];
		if (geoBoundsWidth < 0) {
			geoBoundsWidth += getWidth(projection.getExtent());
		}
		var geoBoundsHeight = geoBoundsRightTop[1] - geoBoundsLeftBottom[1];

		var widthResolution = geoBoundsWidth / pixelBoundsWidth;
		var heightResolution = geoBoundsHeight / pixelBoundsHeight;
		var r = Math.max(widthResolution, heightResolution);
		var scale = r / frameState.viewState.resolution;

		var center = toLonLat(getCenter(frameState.extent), projection);
		
		this.d3Projection
			.scale(scale)
			.center(center)
			.translate([width / 2, height / 2]);

		this.d3Path.projection(this.d3Projection);

		this.vor.attr('d', d => this.d3Path(d))

		let coords = [6.603830043743583, 52.917308513346924];

		this.importArcs
			.attr("d", d => {
				return drawCurve(d3.path(), this.d3Projection(coords), this.d3Projection([d.Lat, d.Lng]))
			})
			.style('stroke-width', d => this.widthScale(+d['Naar Westerbork']))

		this.importArcsSecondLayer
			.attr("d", d => {
				return drawCurve(d3.path(), this.d3Projection(coords), this.d3Projection([d.Lat, d.Lng]))
			})
			.style('stroke-width', d => this.widthScale(+d['Woonwagenbewoners']))

		this.exportArcs
			.attr("d", d => {
				return drawCurve(d3.path(), this.d3Projection([d.Lat, d.Lng]), this.d3Projection(coords))
			})
			.style('stroke-width', d => {
				return this.widthScale(+d['Vrijgelaten in Westerbork '])
			})

		this.arrestment
			.attr('cx', d => this.d3Projection([d.Lat, d.Lng])[0])
			.attr('cy', d => this.d3Projection([d.Lat, d.Lng])[1])
			.attr('r', d => this.rScale(+d['Totaal gearresteerd ']))

		this.svg.attr('width', width);
		this.svg.attr('height', height);

		// this.svg.select('path').attr('d', this.d3Path);

		return this.svg.node();
	};

	return CanvasLayer;
}(Layer));

export default CanvasLayer;